import { StyledText } from '@repo/ui/atoms';
import { ComponentProps, useContext } from 'react';
import { MetadataContext } from '../utils/ContextWrapper';

type Props = {
    label: string;
    align?: ComponentProps<typeof StyledText>['align'];
};

const QuestionTitle = ({ label, align }: Props) => {
    const { fullPage } = useContext(MetadataContext);

    return fullPage ? (
        <StyledText variant="h3" as="h1" align={align}>
            {label}
        </StyledText>
    ) : (
        <StyledText variant="h3" as="h2" align={align}>
            {label}
        </StyledText>
    );
};

export default QuestionTitle;
